import { createActionCreators, createReducerFunction } from 'immer-reducer'
import { LIST_PAGE_SIZE } from 'modules/constants'
import { Progress } from 'modules/types'
import { BasicEntityImmerReducer } from 'modules/utils/helpers/BasicEntityImmerReducer'
import { FetchError } from '../../types'
import {
  Allocation,
  AllocationDTO,
  AllocationListRequestSorting,
  AllocationRequestFilter,
  ProductLimit,
  ProductLimitRequestFilter,
} from '../common/types'
import { TerritoryAllocationEntityState } from './types'

const initialState: TerritoryAllocationEntityState = {
  items: {},
  meta: {},
  ids: [],

  filter: {},
  page: 1,
  total: 0,
  pageSize: LIST_PAGE_SIZE,
  sorting: {},

  retailerProductsLimit: [],

  itemFetchProgress: Progress.IDLE,
  itemFetchErrorDetail: null,
  itemFetchError: null,
  addProgress: Progress.IDLE,
  addError: null,
  addErrorDetail: null,
  updateProgress: Progress.IDLE,
  updateError: null,
  updateErrorDetail: null,
  removeProgress: Progress.IDLE,
  removeError: null,
  removeErrorDetail: null,
  listFetchProgress: Progress.IDLE,
  listFetchError: null,
  listFetchErrorDetail: null,
  retailerProductLimitFetchProgress: Progress.IDLE,
  retailerProductLimitFetchError: null,
  listFetchNextProgress: Progress.IDLE,
  listFetchNextError: null,
  listFetchNextErrorDetail: null,
}

class TerritoryAllocationReducer extends BasicEntityImmerReducer<
  Allocation,
  AllocationRequestFilter,
  AllocationListRequestSorting,
  AllocationDTO,
  AllocationDTO,
  TerritoryAllocationEntityState
> {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  retailerLimitRequested(filter: ProductLimitRequestFilter) {
    this.draftState.retailerProductLimitFetchProgress = Progress.WORK
    this.draftState.retailerProductLimitFetchError = null
  }

  retailerLimitRequestSucceed(productsLimit: ProductLimit[]) {
    this.draftState.retailerProductLimitFetchProgress = Progress.SUCCESS
    this.draftState.retailerProductsLimit = productsLimit
  }

  retailerLimitRequestFailed(error: FetchError) {
    this.draftState.retailerProductLimitFetchProgress = Progress.ERROR
    this.draftState.retailerProductLimitFetchError = error
  }

  clearRetailerProductLimit() {
    this.draftState.retailerProductsLimit = []
  }
}

export const TerritoryAllocationActions = createActionCreators(TerritoryAllocationReducer)
export default TerritoryAllocationActions
export const reducer = createReducerFunction(TerritoryAllocationReducer, initialState)
